import React from 'react';
import useSWR from 'swr';
import { NextSeo } from 'next-seo';

import handleError from 'react-scale/lib/handle-error';

import Main from 'react-scale/components/pages/docs/Main';
import Spinner from 'react-scale/components/elements/spinner';
import { getDocsIndexData } from '../api/docs';

export async function fetchDocsIndexData() {
  const res = await fetch('/api/docs');
  if (!res.ok) {
    throw res.text();
  }
  return res.json();
}

export async function getStaticProps() {
  let props = {};
  try {
    props = await getDocsIndexData();
  } catch (error) {
    handleError(error);
  }
  return { props, revalidate: 1 };
}

const Docs = props => {
  const { data, error, isLoading } = useSWR('docs-index', fetchDocsIndexData, {
    fallbackData: props,
    refreshInterval: 5000
  });

  if (error) return <div>failed to load</div>;
  if (isLoading)
    return (
      <div className="flex items-center justify-center w-screen h-screen bg-white dark:bg-neutral-900">
        <Spinner size="sm" />
      </div>
    );

  return (
    <div className="bg-white dark:bg-neutral-900">
      <NextSeo
        title="Documentation | Scale.com Guide"
        description="Scale AI's mission is to accelerate the development of AI applications. Check out our on demand or enterprise solutions."
        canonical="https://scale.com/docs"
      />
      <Main
        topLevelNavigation={data.topLevelNavigation}
        subLevelNavigation={data.subLevelNavigation}
        index
      />
    </div>
  );
};

Docs.theme = 'light';
Docs.forcedThem = false;
export default Docs;
